import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import MDInput from 'components/MDInput'
import Editor from '../../editor'
import Select from 'react-select'
import { useAgencyInfo } from 'context/agency'
import { useParams } from 'react-router-dom'

const CreateModal = ({ pages, handleRefresh, data }) => {
  const uploadImage = useUploadImage()
    const { page_id } = useParams()
  
  const [agency] = useAgencyInfo()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  const Types = [
    {
      label: 'Popup',
      value: 'Popup',
    },
    {
      label: 'Banner',
      value: 'Banner',
    },
  ]
  const imageOrVideoSelect = [
    {
      label: 'Image',
      value: 'Image',
    },
    {
      label: 'Video',
      value: 'Video',
    },
  ]
  useEffect(async () => {
    console.log(pages,'datadatadata')
  }, [])
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [type, setType] = useState({})
    const [imageOrVideo, setImageOrVideo] = useState({})
    const [content, setContent] = useState('')

    const handleSubmit = async (e) => {
      console.log(type)
      e.preventDefault()
      // setProcessing(true)
      const page = pages?.filter((item) => item._id == page_id)[0]

      const payload = {
        page: page,
        page_id: page_id,
        name: e.target.name.value,
        content: content,
        image_Or_Video: imageOrVideo,
        type: type,
        // agency_id: agency._id,
      }
      console.log(payload)
      // return 0
      if (imageOrVideo?.value === 'Image') {
        console.log(e.target?.image?.files)
        let image_response
        if (e.target?.image?.files?.[0]) {
          image_response = await uploadImage({
            file: e.target?.image?.files[0],
            desiredPath: `app/logo/image`,
          })
        }
        payload['imageLink'] = image_response?.response?.data
      } else if (imageOrVideo?.value === 'Video') {
        payload['videoLink'] = e.target?.videoLink?.value
      }

      console.log(payload, 'payload')
      // return 0
      const { response } = await AppService.notifications.create({ 
        payload: payload,
      })
      console.log(response)
      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      height: 'auto',
      maxHeight: '80vh',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }
    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Notifications
            </MDTypography>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" name="name" fullWidth />
            </MDBox>
            
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Content
              </MDTypography>
              <Editor
                handleChange={(data) => {
                  // console.log('html', data)
                  setContent(data)
                }}
                data={content}
              />
              <MDBox sx={{ fontSize: '15px' }}>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  Add Image or Video
                </MDTypography>
                <Select
                  options={imageOrVideoSelect}
                  isMulti={false}
                  name="image_or_video"
                  onChange={(e) => setImageOrVideo(e)}
                />
              </MDBox>
              {imageOrVideo?.value == 'Image' && (
                <>
                  <MDBox sx={{ fontSize: '15px' }}>
                    <MDTypography
                      variant="button"
                      sx={{ fontSize: '14px', fontWeight: '500' }}
                      mb={1}
                    >
                      Image
                    </MDTypography>
                    <MDBox>
                      <input type="file" name="image" />
                    </MDBox>
                    {/* <MDInput label="Image Url" name="image" fullWidth /> */}
                  </MDBox>
                </>
              )}
              {imageOrVideo?.value == 'Video' && (
                <>
                  <MDBox sx={{ fontSize: '15px' }}>
                    <MDTypography
                      variant="button"
                      sx={{ fontSize: '14px', fontWeight: '500' }}
                      mb={1}
                    >
                      Video
                    </MDTypography>
                    <MDInput label="Video Url" name="videoLink" fullWidth />
                  </MDBox>
                </>
              )}
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Create
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton color="white" size="small" variant="contained" onClick={handlemodal}>
        Create
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal
